import PropTypes from 'prop-types';
import React from 'react';
import RelatedArticles from '../shared/related_articles';
import UrlHelpers from '../shared/url_helpers';
import APIRequest from '../api_request';

const MAX_ARTICLES = 3;

class RelatedArticlesManager extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      articles: [],
    };
  }

  componentDidMount() {
    if (this.props.queryParams) {
      this.fetchArticles();
    }
  }

  get queryParams() {
    return {

      per_page: MAX_ARTICLES,
      ...this.props.queryParams,
    };
  }

  fetchArticles() {
    APIRequest.V3.get(UrlHelpers.relatedArticlesPath, this.queryParams).then((response) => {
      this.setState({ articles: response.articles });
    });
  }

  render() {
    if (!this.state.articles.length) { return null; }
    return (
      <RelatedArticles
        articles={this.state.articles}
        heading={this.props.heading}
      />
    );
  }
}

RelatedArticlesManager.propTypes = {
  queryParams: PropTypes.object,
  heading: PropTypes.string,
};

export default RelatedArticlesManager;
